
window.$ = window.jQuery = require('jquery');
window.cf = window.cf || {}
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import ElementUI from 'element-ui'
import '@/styles/element.css'
import 'normalize.css/normalize.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import FullCalendar from 'vue-full-calendar'
// import 'fullCalendar/dist/fullCalendar.min.css'
import '@/styles/index.scss' // global css
import '@/styles/base.scss'
import '@/styles/vue-treeselect.css'
import './vendor/cf/scripts/cf';

import '@/icons' // icon
// import '@/permission' // permission control
import VuePlugins from './common/js/VuePlugins';
import Axios from 'axios';
import CFScriptHelper from './common/js/CFScriptHelper'
import SessionService from './services/common/SessionService'
import PreloadService from './services/PreloadService';
import VeeValidate from 'vee-validate';
import 'toastr/build/toastr.css';
import './vendor/cf/scripts/libs/cf.toastr.js';

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

const veeConfig = {
  fieldsBagName: 'vee-fields' // 默认为 fields
};
import elDragDialog from '@/vendor/el-dragDialog'
Vue.use(elDragDialog)
Vue.use(ElementUI, { locale })
Vue.use(FullCalendar)
Vue.use(VuePlugins);
Vue.use(VeeValidate, veeConfig);
Vue.use(VXETable)
Vue.config.productionTip = false

Axios
  .all([CFScriptHelper.getCFUserCfg(), SessionService.init()])
  .then(
    Axios.spread((userCfg, session) => {
      // console.log('启动......')
      PreloadService.preloadInit(userCfg, session)
      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    })
  )
  .catch((e) => {
    console.log(e)
  })
  
